import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQueryForGoLang } from '../../utils/baseQuery';

export const dashboardApi = createApi({
  reducerPath: 'goDashboard',
  baseQuery: getBaseQueryForGoLang,
  tagTypes: ['dashboard'],
  endpoints: (builder) => ({
    getDashboard: builder.query<any, any>({
      query: (params) => ({
        url: '/dashboard/',
        method: 'GET',
        params: params,
      }),
    }),
  }),
  refetchOnMountOrArgChange: true,
});

export const { useGetDashboardQuery } = dashboardApi;
